import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import {
  synchronizeShopifyProducts,
  clearSynchronizeShopifyProducts,
} from 'redux/integrations/actions';

import { Checkbox } from 'semantic-ui-react';

import './SynchronizeShopifyCheckbox.css';

class SynchronizeShopifyCheckbox extends Component {
  static propTypes = {
    synchronizeShopifyProducts: PropTypes.func.isRequired,
    clearSynchronizeShopifyProducts: PropTypes.func.isRequired,
    isSynchronized: PropTypes.bool,
  };

  static defaultProps = {
    isSynchronized: null,
  };

  state = {
    firstChange:  null,
    currentSynchronized: null,
  };

  componentDidMount() {
    this.setState({ currentSynchronized: this.props.isSynchronized });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !!this.state.firstChange &&
      prevState.currentSynchronized !== this.state.currentSynchronized
    ) {
      this.props.synchronizeShopifyProducts(this.state.currentSynchronized);
    }
  }

  componentWillUnmount() {
    this.props.clearSynchronizeShopifyProducts();
  }

  onCheckboxChange = () => {
    this.setState({
      firstChange: true,
      currentSynchronized: !this.state.currentSynchronized,
    });
  };

  render() {
    const { isSynchronized } = this.props;
    const { firstChange, currentSynchronized } = this.state;

    return (
      <div className="synchronize-shopify-checkbox__component">
        <Checkbox
          checked={firstChange ? currentSynchronized : isSynchronized}
          onChange={this.onCheckboxChange}
        />
        <div className="checkbox-title">
          Synchronize all Products from Shopify to HeyLink.me
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => (
  {
    synchronizeShopifyProductsSuccess: state.integrationsReducer.synchronizeShopifyProductsSuccess,
  }
);

export default connect(
  mapStateToProps,
  {
    synchronizeShopifyProducts,
    clearSynchronizeShopifyProducts,
  },
)(SynchronizeShopifyCheckbox);
